import { Box, Heading, Text, VStack } from "@chakra-ui/react";
import { motion } from "framer-motion";

const MotionBox = motion(Box);
const MotionHeading = motion(Heading);
const MotionText = motion(Text);
const MotionVStack = motion(VStack);

export default function Story() {
  return (
    <MotionBox
      py={20}
      px={{ base: 6, md: 24 }}
      bg="white"
      textAlign="center"
      initial={{ opacity: 0 }}
      whileInView={{ opacity: 1 }}
      transition={{ duration: 0.8 }}
      viewport={{ once: true }}
    >
      <MotionHeading
        color="sedapePinkDark"
        mb={6}
        initial={{ y: -30, opacity: 0 }}
        whileInView={{ y: 0, opacity: 1 }}
        transition={{ duration: 0.8, type: "spring", stiffness: 60 }}
      >
        Nossa história, seu conforto
      </MotionHeading>

      <MotionVStack spacing={4} maxW="3xl" mx="auto">
        <MotionText
          color="gray.700"
          fontSize="lg"
          initial={{ x: -30, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.2 }}
        >
          A Sedapé Cosmético nasceu da profunda paixão de Thainá pela cosmetologia e do
          desejo genuíno de atender às necessidades reais das pessoas.
        </MotionText>

        <MotionText
          color="gray.700"
          fontSize="lg"
          initial={{ x: 30, opacity: 0 }}
          whileInView={{ x: 0, opacity: 1 }}
          transition={{ duration: 0.8, delay: 0.4 }}
        >
          Incomodada com soluções temporárias, ela iniciou uma jornada para criar um creme
          para os pés que não apenas hidratasse, mas realmente cuidasse da pele uma fusão
          entre ciência e natureza que proporciona conforto, confiança e beleza natural.
        </MotionText>
      </MotionVStack>
    </MotionBox>
  );
}
